<template>
    <div class="user">
        <TitleComponent :title="t('number23')"></TitleComponent>

        <!-- <div class="top">
            <div @click="goBack()"><svg-icon icon-class="fanhui" /></div>
            <div>{{ $t('number23') }}</div>
            <div></div>
        </div> -->
        <div class="userform">
            <el-upload class="avatar-uploader" :limit="1" :http-request="CoverCustomUpload"
                :before-upload="beforeUpload" :show-file-list="false" :disabled="stateUser">
                <div class="avatar">
                    <img class="ava-img" :src="avatar||formData.userform?.avatar " />
                    <img class="photo-icon" src="../../../assets/images/photo.png" alt="" srcset="">
                </div>
            </el-upload>
            <el-form v-if="editType == 2 && !stateUser" ref="registerRef" :model="state.registerForm" label-width="auto" label-position="top" :rules="rulesRegister">
                     
                
                <el-form-item :label="t('login7')" prop="email">
                            <el-input class="input" v-model="state.registerForm.email" />
                        </el-form-item>
                        <el-form-item prop="code" :label="t('login8')" class="form-item">
                            <el-input class="input reset-input" v-model="state.registerForm.code" :placeholder="$t('login9')">
                                <template #append>
                                    <el-button :loading="state.loading" :disabled="state.disabled"
                                        @click="registersend()">
                                        {{ state.text }}
                                    </el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-form>
            <el-form v-else :model="formData.userform" label-width="auto" label-position="top">
                <el-form-item :label="t('login7')">
                    <el-input class="input" v-model="formData.userform.email" disabled />
                </el-form-item>
                <el-form-item :label="t('number26')">
                    <el-input class="input" v-model="formData.userform.nickname" :disabled="stateUser" />
                </el-form-item>
                <el-form-item :label="t('login10')">
                    <el-input class="input" v-model="formData.userform.password" type="password" show-password
                        :disabled="stateUser" />
                </el-form-item>
                <el-form-item label="telegram">
                    <el-input class="input" v-model="formData.userform.telegram" :disabled="stateUser" />
                </el-form-item>
                <el-form-item label="watchApp">
                    <el-input class="input" v-model="formData.userform.watchApp" :disabled="stateUser" />
                </el-form-item>
                <el-form-item :label="t('number27')">
                    <el-input class="input" type="textarea" :rows="2" v-model="formData.userform.introduce"
                        :disabled="stateUser" />
                </el-form-item>
            </el-form>
            <div class="btn-box">
                <div v-if="stateUser == true">
                    <el-button class="btn" type="primary" style="width:100%" round @click="setUser()">{{ $t('number24')
                        }}</el-button>
                </div>
                <div v-else> <el-button class="btn" type="success" style="width:calc(50% - 10px)" @click="submitUser()">{{
                        $t('number25') }}</el-button>
                        <el-button class="btn" type="success" style="width:calc(50% - 10px);background-color: gray;border: 1px solid gray;" @click="stateUser=true">
                            {{$t('setup500')}}</el-button></div>
            </div>
        </div>

    </div>
</template>
<script setup>
import { useUserStore } from '@/stores/userStore'
import { setUserAPI,sendCodeAPI } from '@/apis/user'
import axios from 'axios'

import TitleComponent from '@/components/TitleComponent/index.vue'
import { setshelvesFilterAPI } from '@/apis/pay'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const router = useRouter()
const userStore = useUserStore()
const registerRef = ref()
const editType = ref(1)//1 编辑 2 换绑
const goBack = () => {
    router.go(-1);
}
const stateUser = ref(true)
const rulesRegister = {
    email: [
        { required: true, message: t('login20'), trigger: 'blur' },
        { type: 'email', message: t('login21'), trigger: 'blur' },

    ],
    code: [
        { required: true, message: t('login22'), trigger: 'blur' },
        { min: 4, max: 4, message: t('login23'), trigger: 'blur' }
    ],
}
const setUser = (e) => {
    if(!userStore.userInfo.email){
        ElMessage({ type: 'error', message: t('setup589') })
        editType.value = 2
        stateUser.value = false
        return
    }else{
    editType.value = 1
    stateUser.value = false

    }

}
const state = reactive({
    //发送验证码
    text: t('login16'),
    loading: false,
    disabled: false,
    duration: 60,
    timer: null,
    Resettext: t('login16'),
    Resetloading: false,
    Resetdisabled: false,
    Resetduration: 60,
    Resettimer: null,
    default: {
        text: t('login16'),
        duration: 60
    },
    verifiedModel: false,
    areaCodeList: [],

    registerForm: {
        email: '',
        code: null,
    },
});
const formData = reactive({

    userform: {
        nickname: '',
        mobile: '',
        email: '',
        password: '',
        balance: null,
        telegram: '',
        watchApp: '',
        introduce: '',
        avatar: ''
    }

})
userStore.getUser()
formData.userform = userStore.userInfo
const avatar = ref()
const countdown = () => {

state.disabled = true;

state.timer && clearInterval(state.timer);

state.timer = setInterval(() => {

    const tmp = state.duration--;
    state.text = `${tmp}s`;
    if (tmp <= 0) {
        clearInterval(state.timer);
        state.duration = state.default.duration;
        state.text = state.default.text;
        state.disabled = false;
    }

}, 1000);

};
const registersend = () => {
state.verifiedModel = false
countdown()
registerRef.value.validateField('mobile', async (valid) => {
    if (valid) {
        let data = {
            email: state.registerForm.email,
            type: 3,
        }
        const res = await sendCodeAPI(data)
        console.log(res)
        if (res.code == 0) {

            ElMessage({ type: 'success', message: t('login19') })
        } else {
            ElMessage({ type: 'error', message: res.message })
        }

    }
})
};
// 上传前的检查
const beforeUpload = (file) => {
    // 检查文件类型
    const isValidType = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type)
    if (!isValidType) {
        ElMessage.error(t("number18"))
        return false
    }

    // 检查文件大小（小于10MB）
    const isLt10M = file.size / 1024 / 1024 < 10
    if (!isLt10M) {
        ElMessage.error(t('number19'))
        return false
    }

    return true
}
// 封面上传方法
const CoverCustomUpload = async (options) => {
    try {
        // 1. 获取文件扩展名
        const fileExt = options.file.name.split('.').pop()

        // 2. 调用后端接口获取预签名URL
        const { data: presignedData } = await setshelvesFilterAPI({
            fileExtension: fileExt,
            bucketName: 'shap-head-test'
        })

        // 3. 准备表单数据
        const formData = new FormData()
        // 添加后端返回的所有表单字段
        Object.entries(presignedData.formData).forEach(([key, value]) => {
            formData.append(key, value)
        })
        console.log(presignedData.formData)
        // 添加文件
        formData.append('file', options.file)

        // // 4. 执行上传
        const response = await axios.post(presignedData.url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        // // 5. 上传成功
        if (response.status === 204) {
            ElMessage.success(t("number20"))
            // 构建文件访问URL
            const fileUrl = `${presignedData.url}${presignedData.formData.key}`
            console.log(' formData.userform', fileUrl,avatar)
            // 可以在这里处理上传成功后的逻辑，比如将fileUrl保存到表单中
            avatar.value = fileUrl
            // const res = await setAvatarAPI({ avatar: fileUrl })
            // if (res.code == 0) {
            //     getUser()
            // }

        }
    } catch (error) {
        ElMessage.error(error.message)
        throw error
    }
}
/**
 * 修改用户信息
 */
const submitUser = async () => {
    let data = {
        email: state.registerForm.email,
        code: state.registerForm.code
    }
    if (editType.value == 1) {
        data = {
            nickname: formData.userform.nickname,
            telegram: formData.userform.telegram,
            watchApp: formData.userform.watchApp,
            email: formData.userform.email,
            password: formData.userform.password,
            introduce: formData.userform.introduce

        }

    }
    const res = await setUserAPI(data)
    if (res.code == 0) {
        stateUser.value = true
        userStore.getUser()
        setTimeout(() => {
            formData.userform = userStore.userInfo
        }, 1000);
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
</script>
<style scoped lang="scss">
.user {
    height: 100%;
    background-color: #fff;

  

    .userform {
        padding: 55px 20px 80px 20px;

        .avatar-uploader {
            width: 80px;
            height: 80px;
            margin: 20px auto;

            .avatar {
                position: relative;
                background-image: url('@/assets/images/avatarbg.png');
                /* 背景图片覆盖整个容器，不留空白 */
                background-size: cover;
                /* 背景图片不平铺 */
                background-repeat: no-repeat;
                width: 80px;
                height: 80px;
                border-radius: 50%;
                >img {
                    width: 80px;
                    height: 80px;
                    object-fit: cover;
                    border-radius: 50%;
                }

                .photo-icon {
                    position: absolute;
                    right: -7px;
                    bottom: -2px;
                    width: 29px;
                    height: 29px;
                }
            }
        }

        .input {
            height: 46px;
            border-radius: 8px;
        }
    }

    .btn-box {
        position: fixed;
        bottom: 20px;
        width: calc(100% - 40px);

        >div {
            width: 100%;

            .btn {
                width: 100%;
                height: 40px;
                background: #FC3938;
                border-radius: 20px;
                border: 1px solid #FF4F00;
            }
        }

    }

}
</style>